import React from 'react';
import { RenderTableActionButtons } from '../tableActionButton/tableActionButton';
import {
  formattedList,
  getNameNumberList,
  getNameNumberObject
} from '../../../services/helpers';
import {
  retailCollectionsSummaryTableActionsConfig,
  retailCollectionsSummaryTableConfig
} from '../../containers/retailCollections/retailCollectionsHelper';
import {
  retailCollectionsHandoverTableActionsConfig,
  retailCollectionsHandoverTableConfig,
  retailCollectionsHandoverDateWiseConfig,
  retailCollectionsHandoverDateWiseTableActionsConfig
} from '../../containers/collectionsHandover/collectionsHandoverHelper';

import {
  retailCashbookTableConfig,
  retailCashbookHandoverTransactionConfig,
  depositSlipCashTableConfig,
  depositSlipChequeTableConfig,
  depositSlipButtonConfig
} from '../../containers/retailCashbook/retailCashbookHelper';

import retailCollectionsHandoverCnWiseConfig from '../collectionsHandoverPendingModal/collectionsHandoverPendingModalHelper';
import { existingPrqTableConfig } from '../../containers/pickup/createPrq/createPrqHelper';
import {
  prqDashboardConfig,
  prqDashboardTableActionConfig
} from '../../containers/pickup/dashboard/pickupDashboardHelper';

import {
  shopFloorZoneTableConfig,
  shopFloorZoneButtonConfig
} from '../../containers/shopFloorManagement/zone/zoneHelper';
import {
  masterDataTableConfig,
  masterDataButtonConfig
} from '../../containers/shopFloorManagement/masterData/masterDataHelper';
import {
  nationalLineHaulTableConfig,
  nationalLineHaulButtonConfig
} from '../../containers/networkPlanning/nationalLineHaul/nationalLineHaulHelper';

import bpPassbookDashboardConfig from '../../containers/bpPassbook/dashboard/bpPassbookDashboardHelper';
import {
  externalTrackingRedirectedDashBoardConfig,
  internalTrackingRedirectedDashBoardConfig,
  internalTrackingDashboardConfig,
  externalTrackingDashboardConfig,
  trackingDashboardTableActionConfig
} from '../../containers/bulkCn/dashboard/trackingDashboardHelper';

import {
  incompleteCnDashboardConfig,
  incompleteCnDashboardTableActionConfig,
  incompleteCnRelianceDashboardConfig,
  incompleteCnRelianceDashboardTableActionConfig
} from '../../containers/incompleteCn/dashboard/incompleteCnDashboardHelper';

import {
  blockCNDashboardConfig,
  blockCNDashboardTableActionConfig,
  blockCNButtonConfig
} from '../../containers/blockCN/dashboard/blockCNDashboardHelper';

import {
  ceTaskboardConfig,
  ceTaskboardTableActionConfig,
  poDetailsConfig,
  ceTaskboardHolidayDeliveryConfig,
  ceTaskboardHolidayDeliveryTableActionConfig
} from '../../containers/ceTaskboard/ceTaskboardHelper';

import {
  depositedSlipsDashboardConfig,
  depositedSlipDashboardTableActionConfig
} from '../../containers/depositSlip/dashboard/depositSlipDashboardHelper';

import {
  vasChargesConfig,
  vasChargesActionConfig
} from '../../containers/vasCharges/vasChargesHelper';

import { cnTableConfig } from '../../containers/pickup/pickupTracking/pickupTrackingHelper';

import {
  addressFloorTaggingTableConfig,
  addressFloorTaggingTableActionConfig
} from '../../containers/addressFloorTagging/addressFloorTaggingHelper';

import {
  manageVehiclesTableConfig,
  manageVehiclesTableActionConfig
} from '../../containers/manageVehicles/manageVehiclesHelper';

import {
  bulkCnUsingExcelConfig,
  bulkCnUsingExcelActionConfig,
  preBookCnsTableConfig
} from '../../containers/bulkCnUsingExcel/bulkCnUsingExcelHelper';

import {
  rpCollectionsPendingTableConfig,
  rpCollectionsTableActionsConfig,
  rpCollectionsCompletedTableConfig
} from '../../containers/rpCollections/rpCollectionsHelper';

import {
  cmsTableActionsConfig,
  cmsCompletedTableConfig
} from '../../containers/cms/cmsHelper';

import {
  damageCnUnblockAndRtoDashboardConfig,
  damageCnUnblockAndRtoDashboardTableActionConfig,
  unblockRtoCNButtonConfig
} from '../../containers/damageCnUnblockAndRto/dashboard/damageCnUnblockAndRtoDashboardHelper';
import {
  chargeReconciliationAmountTableActionConfig,
  chargeReconciliationAmountTableConfig,
  chargeReconciliationAmountTableConfigName,
  chargeReconciliationTableActionConfig,
  chargeReconciliationTableConfig
} from '../../containers/chargeReconciliation/helper';

const editImg = require('../../../assets/images/ic_mode_edit_black_24px.svg');
const deleteImg = require('../../../assets/images/ic_delete_black_24px.svg');

export const zoomTableActionsConfig = {
  // Each object is a button. Give it a classname else default will be picked up

  OA_MANAGER: {
    buttons: [
      {
        label: 'DEACTIVATE',
        iconRef: deleteImg,
        onClick: rowData => {
          if (
            zoomTableActionsConfig.OA_MANAGER.actions &&
            zoomTableActionsConfig.OA_MANAGER.actions.deactivateOa
          ) {
            zoomTableActionsConfig.OA_MANAGER.actions.deactivateOa(rowData);
          }
        },
        style: {
          width: '50%',
          height: '85%'
        }
      }
    ]
  },
  RTL_COLLECTIONS_SUMMARY: retailCollectionsSummaryTableActionsConfig,
  RTL_COLLECTIONS_HANDOVER: retailCollectionsHandoverTableActionsConfig,
  RTL_CASHBOOK: {},
  RTL_COLLECTIONS_HANDOVER_DATE_WISE: retailCollectionsHandoverDateWiseTableActionsConfig,
  RTL_COLLECTIONS_HANDOVER_CN_WISE: {},
  RTL_CASHBOOK_TRANSACTION_HANDOVER_KEY: {},
  PRQ_EXISTING_DATE_WISE: {},
  PRQ_DASHBOARD: prqDashboardTableActionConfig,
  DEPOSIT_SLIP_CASH: depositSlipButtonConfig,
  DEPOSIT_SLIP_CHEQUE: depositSlipButtonConfig,
  SHOP_FLOOR_ZONE: shopFloorZoneButtonConfig,
  MASTER_DATA: masterDataButtonConfig,
  NATIONAL_LINE_HAUL: nationalLineHaulButtonConfig,
  BP_PASSBOOK_DASHBOARD: {},
  TRACK_DASHBOARD_INTERNAL: trackingDashboardTableActionConfig,
  TRACK_DASHBOARD_EXTERNAL: trackingDashboardTableActionConfig,
  TRACK_DASHBOARD_EXTERNAL_REDIRECTED: trackingDashboardTableActionConfig,
  TRACK_DASHBOARD_INTERNAL_REDIRECTED: trackingDashboardTableActionConfig,
  BLOCK_CN: blockCNDashboardTableActionConfig,
  BLOCK_CN_BUTTON: blockCNButtonConfig,
  CE_TASKBOARD: ceTaskboardTableActionConfig,
  CE_TASKBOARD_HOLIDAY: ceTaskboardHolidayDeliveryTableActionConfig,
  PO_DETAILS: {},
  INCOMPLETE_CN: incompleteCnDashboardTableActionConfig,
  INCOMPLETE_CN_RELIANCE: incompleteCnRelianceDashboardTableActionConfig,
  DEPOSITED_SLIPS_DASHBOARD: depositedSlipDashboardTableActionConfig,
  VAS_CHARGES: vasChargesActionConfig,
  ADDRESS_FLOOR_TAGGING: addressFloorTaggingTableActionConfig,
  MANAGE_VEHICLES_DASHBOARD: manageVehiclesTableActionConfig,
  BULK_CN_USING_EXCEL: bulkCnUsingExcelActionConfig,
  PRE_BOOK_CN: preBookCnsTableConfig,
  CN_TABLE: {},
  RP_COLLECTION_HANDOVER_PENDING: rpCollectionsTableActionsConfig,
  RP_COLLECTION_HANDOVER_COMPLETED: rpCollectionsTableActionsConfig,
  CMS_COMPLETED: cmsTableActionsConfig,
  DAMAGE_CN_UNBLOCK_RTO_CONFIG: damageCnUnblockAndRtoDashboardTableActionConfig,
  DAMAGE_CN_UNBLOCK_RTO_BUTTON: unblockRtoCNButtonConfig,
  CHARGE_RECONCILIATION: chargeReconciliationTableActionConfig,
  CHARGE_RECONCILIATION_AMOUNT: chargeReconciliationAmountTableActionConfig
};

// The place to sort out all your tables
// Syntax to follow - RouteModule_TabModule
export const zoomTableConfig = {
  OA_MANAGER: {
    columns: [
      {
        Header: 'S.No.',
        // accessor: "id",
        headerClassName: 'flex-20',
        className: 'flex-20',
        Cell: row => row.index + 1
      },
      {
        Header: 'Name',
        headerClassName: 'flex-35',
        accessor: 'name',
        className: 'flex-35',
        sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
      },
      {
        Header: 'Mobile Number',
        headerClassName: 'flex-35',
        accessor: 'mobileNo',
        className: 'flex-35'
      },
      {
        Header: 'Toli',
        headerClassName: 'flex-35',
        accessor: 'toli',
        className: 'flex-35'
      },
      {
        Header: 'Vendor Code',
        headerClassName: 'flex-35',
        accessor: 'vendorCode',
        className: 'flex-35',
        sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
      },
      {
        Header: 'Vendor Name',
        headerClassName: 'flex-35',
        accessor: 'vendorName',
        className: 'flex-35',
        sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
      },
      {
        Header: 'Actions',
        headerClassName: 'flex-10',
        className: 'flex-10',
        sortable: false,
        Cell: obj => (
          <RenderTableActionButtons
            rowData={obj.original || {}}
            buttonConfig={zoomTableActionsConfig.OA_MANAGER.buttons}
          />
        )
      }
    ],
    className: 'zoomTableLegacyWrapper',
    noDataText: 'No OAs found',
    minRows: 7,
    pageSizeOptions: [7, 10, 15, 25, 50, 100],
    style: { maxHeight: 'calc(100vh - 21rem)' }
  },
  RTL_COLLECTIONS_SUMMARY: retailCollectionsSummaryTableConfig,
  RTL_COLLECTIONS_HANDOVER: retailCollectionsHandoverTableConfig,
  RTL_CASHBOOK: retailCashbookTableConfig,
  RTL_COLLECTIONS_HANDOVER_DATE_WISE: retailCollectionsHandoverDateWiseConfig,
  RTL_COLLECTIONS_HANDOVER_CN_WISE: retailCollectionsHandoverCnWiseConfig,
  RTL_CASHBOOK_TRANSACTION_HANDOVER_KEY: retailCashbookHandoverTransactionConfig,
  PRQ_EXISTING_DATE_WISE: existingPrqTableConfig,
  PRQ_DASHBOARD: prqDashboardConfig,
  DEPOSIT_SLIP_CASH: depositSlipCashTableConfig,
  DEPOSIT_SLIP_CHEQUE: depositSlipChequeTableConfig,
  SHOP_FLOOR_ZONE: shopFloorZoneTableConfig,
  MASTER_DATA: masterDataTableConfig,
  NATIONAL_LINE_HAUL: nationalLineHaulTableConfig,
  BP_PASSBOOK_DASHBOARD: bpPassbookDashboardConfig,
  BLOCK_CN: blockCNDashboardConfig,
  INCOMPLETE_CN: incompleteCnDashboardConfig,
  INCOMPLETE_CN_RELIANCE: incompleteCnRelianceDashboardConfig,
  TRACK_DASHBOARD_INTERNAL: internalTrackingDashboardConfig,
  TRACK_DASHBOARD_EXTERNAL: externalTrackingDashboardConfig,
  TRACK_DASHBOARD_EXTERNAL_REDIRECTED: externalTrackingRedirectedDashBoardConfig,
  TRACK_DASHBOARD_INTERNAL_REDIRECTED: internalTrackingRedirectedDashBoardConfig,
  CE_TASKBOARD: ceTaskboardConfig,
  CE_TASKBOARD_HOLIDAY: ceTaskboardHolidayDeliveryConfig,
  PO_DETAILS: poDetailsConfig,
  DEPOSITED_SLIPS_DASHBOARD: depositedSlipsDashboardConfig,
  VAS_CHARGES: vasChargesConfig,
  ADDRESS_FLOOR_TAGGING: addressFloorTaggingTableConfig,
  MANAGE_VEHICLES_DASHBOARD: manageVehiclesTableConfig,
  BULK_CN_USING_EXCEL: bulkCnUsingExcelConfig,
  PRE_BOOK_CN: preBookCnsTableConfig,
  CN_TABLE: cnTableConfig,
  RP_COLLECTION_HANDOVER_PENDING: rpCollectionsPendingTableConfig,
  RP_COLLECTION_HANDOVER_COMPLETED: rpCollectionsCompletedTableConfig,
  DAMAGE_CN_UNBLOCK_RTO_CONFIG: damageCnUnblockAndRtoDashboardConfig,
  CHARGE_RECONCILIATION: chargeReconciliationTableConfig,
  CHARGE_RECONCILIATION_AMOUNT: chargeReconciliationAmountTableConfig,
  CMS_COMPLETED: cmsCompletedTableConfig
};
